import { Field, FieldAttributes, FieldProps } from 'formik';
import { forwardRef, useMemo } from 'react';
import Select, { SelectProps } from './Select';

interface FormikSelectProps extends SelectProps {
    fieldProps?: FieldAttributes<any>;
}

const FormikSelect = forwardRef<HTMLSelectElement, FormikSelectProps>((props, ref) => {
    const { name, id, fieldProps, invalid, ...rest } = props;

    const idOrName = useMemo(() => {
        return id || name;
    }, [id, name]);

    return (
        <Field name={name} {...fieldProps}>
            {({ field, meta }: FieldProps) => (
                <Select
                    {...rest}
                    {...field}
                    ref={ref}
                    id={idOrName}
                    name={name}
                    invalid={(meta.touched && Boolean(meta.error)) || invalid}
                />
            )}
        </Field>
    );
});

export default FormikSelect;
